
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetogoacab() {



    const cardData =
    {
        keyword: ' Pune to Goa Cabs',
        heading: 'S9 Travels:  Pune to Goa Cabs',
        headingDescription: 'Looking for reliable Pune to Goa cabs? S9 Travels offers comfortable and affordable cab services from Pune to Goa, ensuring a smooth, safe, and enjoyable road trip. Covering a distance of approximately 450 km, our Pune to Goa taxi service typically takes 8 to 10 hours, depending on traffic and route conditions. Whether you are heading to Goa for a beach vacation, a family trip, or a weekend getaway, our well-maintained fleet, experienced drivers, and excellent customer service ensure a stress-free travel experience. Choose from a range of vehicles to suit your comfort and budget.',

        top: 'Top Places to Visit in Goa with S9 Travels',
"topPlaces": [
  {
    "title": "Baga Beach",
    "description": "Baga Beach is one of Goa’s most popular beaches, and a perfect stop when traveling by Pune to Goa cabs. Known for its lively nightlife, water sports, and beach shacks with delicious seafood, it’s a must-visit destination."
  },
  {
    "title": "Calangute Beach",
    "description": "Calangute Beach, the largest in North Goa, is a top attraction on a Pune to Goa cab journey. Enjoy thrilling adventure activities, bustling local markets, and vibrant nightlife all in one place."
  },
  {
    "title": "Fort Aguada",
    "description": "Fort Aguada is a 17th-century Portuguese fort offering panoramic views of the Arabian Sea. Easily accessible by Pune to Goa cabs, it’s a historical gem that adds depth to your Goa trip."
  },
  {
    "title": "Basilica of Bom Jesus",
    "description": "A UNESCO World Heritage Site and key stop for travelers using Pune to Goa cabs, this church houses the mortal remains of St. Francis Xavier and stands as an architectural marvel."
  },
  {
    "title": "Dudhsagar Waterfalls",
    "description": "One of India’s tallest waterfalls, Dudhsagar Falls is a scenic highlight when traveling from Pune to Goa by cab. Its beauty is especially stunning during the monsoon season."
  },
  {
    "title": "Chapora Fort",
    "description": "Famous for its appearance in Bollywood films, Chapora Fort offers incredible views of Vagator Beach. Make it a stop on your Pune to Goa cab route for stunning sunsets and photo opportunities."
  },
  {
    "title": "Anjuna Flea Market",
    "description": "The Anjuna Flea Market is a vibrant shopping destination you can explore during your Pune to Goa cab trip. Discover handicrafts, jewelry, clothing, and local souvenirs in a colorful setting."
  },
  {
    "title": "Palolem Beach",
    "description": "Palolem Beach in South Goa is a peaceful, scenic destination perfect for relaxing. Book Pune to Goa cabs to reach this less crowded beach and enjoy the tranquility of nature."
  },
  {
    "title": "Se Cathedral",
    "description": "One of Asia’s largest churches, Se Cathedral is a spiritual and architectural landmark. Easily reached via Pune to Goa cabs, it’s a must-see for history and culture enthusiasts."
  },
  {
    "title": "Casino Royale Goa",
    "description": "Enjoy luxury gaming and entertainment aboard Casino Royale Goa, a floating casino on the Mandovi River. Arrive in comfort and style with Pune to Goa cabs."
  }
],

"services": [
  {
    "name": "Pune to Goa Cab Service",
    "description": "Book a reliable and comfortable Pune to Goa cabs service for your next trip. Whether it's for a vacation, business, or family getaway, we provide smooth and enjoyable travel to Goa."
  },
  {
    "name": "Book Pune to Goa Taxi",
    "description": "Booking a Pune to Goa taxi is simple and easy. Choose from a variety of vehicles to ensure a comfortable and stress-free ride to one of India's most beautiful beach destinations."
  },
  {
    "name": "Affordable Pune to Goa Cab",
    "description": "Enjoy affordable Pune to Goa cab services without compromising on comfort. We offer cost-effective solutions for your journey, ensuring you get the best value for your money."
  },
  {
    "name": "Private Taxi for Goa from Pune",
    "description": "Opt for a private taxi for your journey from Pune to Goa. Enjoy a personalized experience with exclusive comfort, perfect for families or groups seeking a private and relaxed ride."
  },
  {
    "name": "Pune to Goa One-Way or Round Trip",
    "description": "Choose one-way or round-trip options for your journey from Pune to Goa. Our flexible and convenient services cater to your travel needs, ensuring a hassle-free trip."
  },
  {
    "name": "Luxury Cab from Pune to Goa",
    "description": "Travel in style with our luxury cabs from Pune to Goa. Experience premium services including plush interiors, air conditioning, and more for a top-tier travel experience."
  },
  {
    "name": "Comfortable Taxi Ride for Goa",
    "description": "Enjoy a comfortable and smooth taxi ride from Pune to Goa. Our well-maintained vehicles and professional drivers ensure a pleasant and safe journey throughout."
  },
  {
    "name": "Goa Sightseeing by Taxi from Pune",
    "description": "Explore the scenic beauty and famous attractions of Goa with a private taxi from Pune. Visit popular beaches, historic churches, local markets, and more at your own pace."
  },
  {
    "name": "Group Travel to Goa from Pune",
    "description": "Traveling with a group? Our spacious cabs are perfect for group travel from Pune to Goa. Enjoy a comfortable ride with ample space for all passengers and their luggage."
  }
],
  "tableData": [
    ["Pune to Goa Cab Service", "Book Pune to Goa Taxi"],
    ["Affordable Pune to Goa Cab", "Private Taxi for Goa from Pune"],
    ["Pune to Goa One-Way or Round Trip", "Luxury Cab from Pune to Goa"],
    ["Comfortable Taxi Ride for Goa", "Goa Sightseeing by Taxi from Pune"],
    ["Group Travel to Goa from Pune", "Pune to Goa One-Way or Round Trip"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we ensure that your trip from Pune to Goa is smooth and timely. Whether you're traveling for a vacation or business, our drivers are punctual and dedicated to providing you with a timely and comfortable ride to Goa."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "Our Toyota Innova is the perfect vehicle for your long journey from Pune to Goa. With comfortable seating, air conditioning, and plenty of space for luggage, you’ll enjoy a relaxing and comfortable ride, making your trip more enjoyable."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced and familiar with the best routes between Pune and Goa. They are professional, courteous, and ensure a smooth, safe, and comfortable journey, giving you the confidence to relax during your trip."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Pune to Goa ride. You’ll receive a clear breakdown of all costs upfront, with no hidden charges, so you can plan your travel budget comfortably."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our priority. Our Toyota Innova vehicles are equipped with modern safety features such as airbags, seat belts, and GPS tracking, ensuring that you have a safe and comfortable journey from Pune to Goa."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels is available 24/7, so whether you have an early morning flight or a late-night arrival in Goa, we’ll ensure that your ride is ready. Our customer service team is always available to assist with your bookings at any time."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Goa cab is easy with S9 Travels. You can book online through our website or mobile app, or you can contact our customer service team for personalized assistance in booking your ride."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "We offer customized travel packages for your Pune to Goa journey. Whether you need additional stops along the way or want to make the trip more personalized, we tailor the journey to meet your specific preferences."
  }
]










    }



    const faqData = [
        [
          {
            question: 'How can I book a cab from Pune to Goa with S9 Travels?',
            answer: 'Booking a cab for your Pune to Goa trip is easy! You can book online via our website or mobile app, or contact our customer service team for assistance with your booking.'
          },
          {
            question: 'What types of cabs are available for Pune to Goa travel?',
            answer: 'We offer a variety of vehicles, including the spacious Toyota Innova, perfect for families, groups, or travelers with a lot of luggage. Choose the vehicle that suits your needs for a comfortable and scenic journey to Goa.'
          },
          {
            question: 'Are the drivers experienced for the Pune to Goa route?',
            answer: 'Yes, our drivers are highly experienced and familiar with the best routes from Pune to Goa. They ensure a smooth, safe, and timely journey for all passengers.'
          },
          {
            question: 'What payment options are available for booking a cab from Pune to Goa?',
            answer: 'We offer multiple payment options, including cash, credit/debit cards, and secure online payments via our app, making it convenient to pay for your ride.'
          },
          {
            question: 'Can I book a round trip from Pune to Goa?',
            answer: 'Yes, we offer round-trip bookings. Just provide us with your return details, and we’ll ensure a smooth and comfortable ride back from Goa to Pune.'
          },
          {
            question: 'Are there any extra charges for detours or waiting time during the trip?',
            answer: 'Any extra charges for detours or waiting time will be communicated upfront, ensuring full transparency in pricing.'
          },
          {
            question: 'Can I make additional stops on the way to Goa?',
            answer: 'Yes, you can request additional stops during your trip. Please let us know during the booking process, and we’ll accommodate your requests for detours or stops along the way.'
          },
          {
            question: 'What is the luggage allowance for a cab on the Pune to Goa trip?',
            answer: 'The Toyota Innova offers plenty of space for standard luggage. If you have more luggage or special requirements, please let us know when booking, and we will make the necessary arrangements.'
          },
          {
            question: 'Does S9 Travels provide corporate travel services for Pune to Goa?',
            answer: 'Yes, we offer corporate travel services for business trips from Pune to Goa. We ensure a professional, comfortable, and timely service for business travelers.'
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Goa cab booking?',
            answer: 'S9 Travels offers a reliable, safe, and comfortable ride with professional drivers, well-maintained vehicles, and excellent customer service, ensuring a smooth and enjoyable journey from Pune to Goa.'
          }
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Rajesh Patil',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab from Pune to Goa with S9 Travels, and it was an incredible experience. The driver was courteous and professional, the car was clean and comfortable, and the journey was smooth and enjoyable. I highly recommend S9 Travels for anyone traveling to Goa!”'
        },
        {
          name: 'Mrs. Nisha Desai',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our family traveled from Pune to Goa with S9 Travels, and the experience was fantastic. The vehicle was spacious, clean, and well-maintained. The driver ensured our safety and comfort throughout the journey. I’ll definitely book again for future trips.”'
        }
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


//    const productSchema = {
//   "@context": "https://schema.org",
//   "@type": "Product",
//   "name": "Pune to Goa Cabs",
//   "image": "https://s9travels.com/images/keyword/100.jpg",
//   "description": "Comfortable and reliable cab service from Pune to Goa offered by S9 Travels. We provide a range of vehicles—hatchbacks, sedans, SUVs—for one-way or round-trip journeys with transparent pricing and professional drivers.",
//   "brand": {
//     "@type": "Brand",
//     "name": "S9 Travels"
//   },
//   "sku": "P2G-001", 
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "bestRating": "5",
//     "worstRating": "1",
//     "ratingValue": "4.8",
//     "ratingCount": "4150"
//   },
//   "offers": {
//     "@type": "Offer",
//     "priceCurrency": "INR",
//     "price": "7000",
//     "priceValidUntil": "2025-12-31",
//     "availability": "https://schema.org/InStock",
//     "url": "https://s9travels.com/Pune-to-Goa-Cabs"
//   }
// };
      // by this 2:10 showing 
      
   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Goa Cabs",
  "image": "https://s9travels.com/assets/images/pune-to-goa-cab.jpg", // Replace with actual image path
  "description": "Comfortable and reliable cab service from Pune to Goa offered by S9 Travels. We provide a range of vehicles—hatchbacks, sedans, SUVs—for one-way or round-trip journeys with transparent pricing and professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "S9 Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4150"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7000",
    "availability": "https://schema.org/InStock",
    "url": "https://s9travels.com/Pune-to-Goa-Cabs"
  }
};




     
   

    return (
        <div>

{/* 
      <Helmet>
  <title>Pune to Goa Cabs | Affordable Taxi Services | S9 Travels</title>
  <meta 
    name="description" 
    content="Book reliable Pune to Goa cabs with S9 Travels. Choose luxury taxis, SUVs, or affordable rides with experienced drivers at competitive rates.." 
  />
  <script type="application/ld+json"> 
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

*/}




<Helmet>
  {/* Primary Meta Tags */}
  <title>Pune to Goa Cab Booking | Affordable Taxi & Car Rental | S9 Travels</title>
  <meta
    name="description"
    content="Book Pune to Goa cabs with S9 Travels. Choose from sedans, SUVs, or luxury taxis at affordable rates. Reliable drivers, 24x7 support, and easy online booking."
  />
  <meta
    name="keywords"
    content="Pune to Goa cab, Pune to Goa taxi, Pune to Goa car rental, Pune to Goa one way cab, Pune to Goa outstation taxi, S9 Travels Pune"
  />
  <link rel="canonical" href="https://www.s9travels.com/pune-to-goa-cabs" />

  {/* Open Graph / Facebook */}
  <meta property="og:title" content="Pune to Goa Cabs | Affordable Taxi Services | S9 Travels" />
  <meta property="og:description" content="Book reliable Pune to Goa taxi service with S9 Travels. Luxury and budget cabs, experienced drivers, 24x7 booking support." />
  <meta property="og:image" content="https://www.s9travels.com/images/pune-goa-cabs.jpg" />
  <meta property="og:url" content="https://www.s9travels.com/pune-to-goa-cabs" />
  <meta property="og:type" content="website" />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Pune to Goa Cabs | Affordable Taxi Services | S9 Travels" />
  <meta name="twitter:description" content="Book Pune to Goa cabs online with S9 Travels. Sedans, SUVs & luxury taxis at competitive fares with trusted drivers." />
  <meta name="twitter:image" content="https://www.s9travels.com/images/pune-goa-cabs.jpg" />
   <script type="application/ld+json"> 
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/100.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetogoacab;